module.exports = __webpack_public_path__ + "static/img/end.ac21f68c.jpg";